import CompanyService from '@/services/Company.js';

export default {
  data: () => ({
    userList: [],
    userListIsLoading: false,
  }),
  computed: {
    companyMemberOptions() {
      return this.userList.map(user => ({
        id: user.id,
        firstname: user.firstname,
        lastname: user.lastname,
        fullname: user.firstname + ' ' + user.lastname,
      }));
    },
  },
  created() {
    this.userListIsLoading = true;

    CompanyService
      .getMembers(this.$root.currentCompany.id)
      .then(users => this.userList = users)
      .catch(() => this.error(this.tr('Failed to load members.')))
      .finally(() => this.userListIsLoading = false);
  },
  methods: {
    validateSelectedUsers(selectedOptions) {
      const availableUserIds = this.userList.map(user => user.id);

      for (const userId of selectedOptions) {
        if (!availableUserIds.includes(userId)) {
          this.error(this.tr('One of the selected users is no longer available.'));
          return false;
        }
      }

      return true;
    },
  },
};
